import React from "react";
import Header from "../components/header/Header";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";

const Layout = () => {
  return (
    <>
      <Header />
      <div className="app-content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Layout;
